import React from 'react';
import { Mail, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-cream py-16 border-t border-peach-light/50" data-id="element-140">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-141">
        <div className="mb-8" data-id="element-142">
          <span className="text-2xl font-serif italic text-peach-dark font-bold" data-id="element-143">
            🌸 Aula Mater™
          </span>
        </div>

        <p className="text-text-muted max-w-lg mx-auto mb-8 leading-relaxed" data-id="element-144">
          Contenido educativo y herramientas prácticas para acompañar la
          maternidad desde un lugar más humano, tranquilo y real.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-12" data-id="element-145">
          <a href="mailto:soporteaulamater@gmail.com" className="flex items-center gap-2 text-text-dark hover:text-peach transition-colors" data-id="element-146">
            <Mail className="w-5 h-5" data-id="element-147" />
            soporteaulamater@gmail.com
          </a>
          <a href="#" className="flex items-center gap-2 text-text-dark hover:text-peach transition-colors" data-id="element-148">
            <Instagram className="w-5 h-5" data-id="element-149" />
            @aulamater_
          </a>
        </div>

        <div className="text-xs text-text-muted/70 space-y-2" data-id="element-150">
          <p data-id="element-151">
            © 2026 Aula Mater™ — Todos los derechos reservados. Prohibida la
            reproducción y redistribución sin autorización expresa.
          </p>
          <p data-id="element-152">
            Este material tiene fines informativos y educativos. No reemplaza la
            consulta médica profesional.
          </p>
        </div>
      </div>
    </footer>;
}